export default {
    manufacturerId: "Id Fabricante",
    companyId: "Id Compañía",
    manufacturerName: "Fabricante",
    deviceCategory: "Categoría del Dispositivo",
    promilesOdometerCalculated: "Odometro de Promiles Calculado",
    simProviderAccountId: "Id de Cuenta del Proveedor de la SIM",
    deviceModelId: "Id del Modelo del Dispositivo",
    esn: "ESN",
    jbus: "Jbus",
    vbus: "Vbus",
    label: "Etiqueta",
    reference: "Referencia",
    iccid: "ICCID",
    promiles: "Promiles",
    imei: "IMEI",
    msisdn: "MSISDN",
    data_details_title: "Detalles de los Datos",
    useEcuVin: "Use Ecu Vin",
    driverBehavior: "Driver Behavior",
    apu: "Apu",
    linkedMode: "Modo emparejado",
    hybrid: "Híbrido",
    useEcuOdometer: "Uso del cuentakilómetros Ecu",
    hoursEnable: "Habilitar Horas",
    pressurePro: "Presión Pro",
    obd2Alerts: "Alertas Obd2",
    useEcuEngineHours: "Uso Ecu Horas Motor",
    analytic: "Analítica",
    odometerEnable: "Activar Cuentakilómetros",
    product: "Producto",
    output: "Salida",
    input: "Entrada",
    ttu: "TTU",
    ota: "OTA",
    sms: "SMS",
    comData: "ComData",
    battery: "Batería",
    show: "Mostrar",
    tow: "Remolque",
    starter: "Inicio",
    motion: "Movimiento",
    analytics: "Analítica",
    geofence: "Geofence",
    timezoneId: "Id. de zona horaria",
    customRoleId: "Id. de rol personalizado",
    cognitoAuth: "Cognito Auth",
    devicesCount: "Conteo de dispositivos",
    hasPromiles: "Promiles",
    promilesLogin: "Nombre de usuario de Promiles",
    promilesEmail: "Correo electrónico de Promiles",
    fuelCardCompanyCode: "Fuel Card Company Code",
    brand: "Nombre de la marca",
    dealerId: "ID de marca",
    sm: "SM",
    email: "Correo electrónico",
    euiccid: "EUICCID",
    deviceID: "ID del dispositivo",
    modemID: "Id de módem",
    endConsumerId: "Id. del consumidor final",
    requestAccepted: "Solicitud aceptada",
    cmdID: "Cmd ID",
    data: "Datos",

    processed: "Procesadas",
    entityName: "Tipo",
    entityIds: "Para Procesar",

    assetSubtypes: "Subtipos de activos",
    account: "Cuenta",
    units: "Unidades",
    drivers: "Conductores",
    subUsers: "Subusuarios",
    assets: "Activos"
};